<template>
  <div class="layout-head-nav bgff">
    <el-menu
      :default-active="activeMenu.path"
      text-color="#333"
      active-text-color="#fff"
      :unique-opened="true"
      mode="horizontal"
      class="f-b-c def-w"
    >
      <nav-item
        v-for="route in menus"
        :key="route.id"
        :active-index="activeMenu.path"
        :item="route"
        :base-path="route.path"
      />
      <!--      <div class="menu-nav-item no-router" @click.stop="open7moor">
        <el-menu-item :index="null">
          <span>在线客服</span>
        </el-menu-item>
      </div>-->
    </el-menu>
  </div>
</template>

<script>
import NavItem from "@/layout/components/LayoutHead/HeadNav/NavItem.vue";
import { mapGetters } from "vuex";
import open7moor from "@/utils/use7moor";
export default {
  name: "HeadNav",
  components: { NavItem },
  props: {},
  data() {
    return {};
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(["menus", "activeMenu"])
  },
  watch: {
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {
    open7moor
  }
};
</script>

<style scoped lang="scss">
::v-deep{
  .el-scrollbar__wrap{
    overflow-y: hidden;
    overflow-x: hidden;
    width: 100%;
    margin: 0 !important;
  }
}
.layout-head-nav {
  width: 100%;
}
</style>
